<template>
    <div>
        <component
            v-if="data.length !== 0"
            :is="'VuePerfectScrollbar'"
            class="scroll-area-emcfull-content md:px-8 md:pb-8 px-6 pb-6"
            :settings="settings"
            :key="$vs.rtl"
        >
            <div class="vx-row my-4" v-for="(item, i) in data" :key="i + 'cf'">
                <div class="vx-col w-full">
                    <!-- Название дисциплины  -->
                    <vx-card
                        class="px-4 vs-con-loading__container"
                        :id="`div-with-loading${item.uid}`"
                    >
                        <div class="flex flex-wrap items-center">
                            <span class="font-semibold"
                                >{{ $t("discipline") }}:
                            </span>
                            <span class="ml-2">{{ item.discipline }}</span>
                        </div>
                        <!-- Статус -->
                        <div>
                            <vx-tooltip
                                :text="item.listStatus[item.status_d.number]"
                                position="bottom"
                                class="flex items-center my-2"
                                style="width: 145px"
                            >
                                <span class="font-semibold"
                                    >{{ $t("status") }}:
                                </span>
                                <div class="mx-2">
                                    <feather-icon
                                        :style="
                                            statusColor[
                                                item.status_d.number - 1
                                            ]
                                        "
                                        :icon="
                                            statusIcons[
                                                item.status_d.number - 1
                                            ]
                                        "
                                    ></feather-icon>
                                </div>
                            </vx-tooltip>
                        </div>

                        <!-- Форма контроля -->
                        <div class="flex flex-wrap">
                            <vs-checkbox
                                v-for="checkbox in item.select"
                                v-model="selected[checkbox.uid]"
                                class="my-2"
                                :value="checkbox.uid"
                                :key="checkbox.uid"
                                @change="sendListSelected(item, checkbox.uid)"
                                :disabled="item.status_d.number === 4||closed_data "
                            >
                                {{ checkbox.name }}
                            </vs-checkbox>
                        </div>
                    </vx-card>
                </div>
            </div>
        </component>
        <!-- Сообщение данных нет или выберите академ период -->
        <div class="mt-4 ml-5 mr-5" v-else>
            <vs-alert active="true">
                {{
                    acadFilter ? $t("select_academPeriud") : $t("no_data_text")
                }}
            </vs-alert>
        </div>
    </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapMutations } from "vuex";
export default {
    props: {
        data: {
            required: true,
            type: Array,
        },
        acadFilter: {
            required: false,
            type: Boolean,
        },
        status:{
            type:Object
        }

    },
    data() {
        return {
            showThread: false,
            settings: {
                maxScrollbarLength: 80,
                wheelSpeed: 1,
            },
            selectLang: null,
            selectTeacher: null,
            teacherItems: [],
            statusIcons: [
                "AlertCircleIcon",
                "CheckSquareIcon",
                "XCircleIcon",
                "CheckCircleIcon",
                "EditIcon",
            ],
            statusColor: [
                "color: orange",
                "color: #0000ff",
                "color: red",
                "color: green",
                "color: #8000ff",
            ],
            selected: [],
            closed_data:false
        };
    },
    watch: {
        data() {
            this.updateSelectCheckbox();

        },
    },

    created() {

        this.updateSelectCheckbox();
        this.$http.get(
            `/organizations/uid_get_discipline_credit/`+this.data[0].discipline_credit+`/`,
        ).then((res)=>{this.closed_data = res.data.closedt})
    },
    mounted() {},

    methods: {
        ...mapMutations({ editStateStudent: "User/SET_STATE" }),
        // Обновление checkbox из state
        updateSelectCheckbox() {
            this.data.forEach((item) => {
                item.chosen_control_forms.forEach((c) => {
                    this.selected[c] = true;
                });
            });
        },
        // При нажатии на checkbox
        async sendListSelected(item, uid) {
            this.$vs.loading({
                color: "primary",
                container: `#div-with-loading${ item.uid }`,
                scale: 0.45,
            });
            // Выбранный checkbox проверяется и добавляется в массив
            if (this.selected[uid] === true) {
                item.chosen_control_forms.push(uid);
            } else {
                item.chosen_control_forms = item.chosen_control_forms.filter(
                    (c) => c !== uid
                );
            }
            // Запрос с отправкой
            const response = await this.$http.put(
                `user/control_forms/${ item.discipline_credit }/choose/`,
                { chosen_control_forms: item.chosen_control_forms }
            );

            // Изменение статуса
            if (
                this.$route.name === "registration-of-disciplines" &&
                item.chosen_control_forms.length > 0
            )
                item.status_d.number = 2;
            if (
                this.$route.name === "registration-of-disciplines" &&
                item.chosen_control_forms.length === 0
            )
                item.status_d.number = 1;
            // ...(this.$route.name === "isc_students" && { number: 5 }),
            // ...(this.$route.name === "isc_students" && {
            //     author: `${this.user.lastName} ${this.user.firstName} ${this.user.middleName}`,
            // }),

            // Показ скрытие  страницы Дипломный проект
            const data = await this.$http.get(
                "advisors/thesis_topic?get_status=true"
            );

            await this.editStateStudent({
                name: "statusShowPageChangeTopicDiplomaProject",
                data,
            });

            this.$vs.loading.close(
                `#div-with-loading${ item.uid } > .con-vs-loading`
            );
        },
    },

    components: {
        VuePerfectScrollbar,
    },
};
</script>

 <style lang="scss" scoped>
.todo__filters-container {
    .multiselect__single {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
.full-vs-sidebar .vs-sidebar {
    max-width: 100%;
}

.scroll-area-emcfull-content {
    position: relative;
    width: 100%;
    height: calc(100% - 85px);
    .archive_link {
        color: #ffffff !important;
    }
}
@media only screen and (max-width: 900px) {
    .scroll-area-emcfull-content {
        padding-left: 1rem !important;
        padding-right: 1rem !important;
    }
}
</style>
